import { Box } from '@common-fe/common-fe';
import styled, { css } from 'styled-components';

export const CardItemWrapper = styled(Box)<{ $isFlipDisabled?: boolean }>`
  width: 480px;
  position: relative;

  ${({ $isFlipDisabled }) => $isFlipDisabled && css`
    pointer-events: none;
  `}
`;

export const CardLoggedTooltip = styled(Box)`
  position: absolute;
  width: 100%;
  z-index: 100;
  top: -19px;
`;

interface CardStatusActionWrapProps {
  width?: string;
  height?: string;
  padding?: string;
  $withBorderShadow?: boolean;
}

export const CardStatusActionWrap = styled(Box)<CardStatusActionWrapProps>`
  height: ${({ height }) => height || '252px'};
  width: ${({ width }) => width || '300px'};
  padding: ${({ padding, theme }) => padding || `${theme.spacings.spacing32} ${theme.spacings.spacing24}`};

  ${({ $withBorderShadow, theme }) => $withBorderShadow && css`
    box-shadow: inset 0 0 0 1px ${theme.colors.border2};
  `}
`;
